import React, { useMemo, useRef } from "react";

import { Layout } from "layouts";
import { connect } from "react-redux";
import { withHuggg, withRedirect } from "hoc";
import { compose } from "redux";
import { getSegments, getRedeemedSegment } from "redux/modules/huggg";
import GuidedChoiceFlow from "components/GuidedChoice/GuidedChoiceFlow";
import SegmentCarousel from "../../components/Redeem/Method/Voucher/Segments/SegmentCarousel";
import { getBasePathname } from "utilities/huggg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import dictionary from 'config/dictionary';
import { getSelectedSegment, setSelectedSegment } from "redux/modules/selectedSegment";
import { ConfirmationDialog } from "components/ui";
import ConfirmationBody from "components/Redeem/Method/Voucher/Segments/ConfirmationBody";
import ConfirmationHeader from "components/Redeem/Method/Voucher/Segments/ConfirmationHeader";
import { getBrand } from "redux/modules/brand";

export const ChooseUnconnected = props => {
    const { multiSegmentFlow, selectedSegment, segments, setSelectedSegment, huggg, brand } = props;
    const confirmDialogRef = useRef();
    const history = useHistory();

    const isGuidedChoice = useMemo(() => multiSegmentFlow === 'guided-choice', [multiSegmentFlow])
    const segmentName = useMemo(() => selectedSegment ? selectedSegment.name : '', [selectedSegment]);

    const shouldShowConfirmation = segment => segment && !['form-redemption', 'pin4', 'prepaid-card'].includes(segment.voucherType)

    const onSelectSegment = segment => {
        setSelectedSegment(segment);

        if (shouldShowConfirmation(segment)) {
            confirmDialogRef.current.open();
        } else {
            history.push(`${getBasePathname(huggg)}/redeem`)
        }
    }

    const onConfirmationConfirmClick = () => {
        confirmDialogRef.current.close();
        history.push(`${getBasePathname(huggg)}/redeem`)
    };

    const onConfirmationCancelClick = () => confirmDialogRef.current.close();

    return <Layout>
        <ConfirmationDialog
            data-test-id="confirmation-modal"
            body={<ConfirmationBody brandName={brand.name} />}
            cancelButtonText={dictionary.segments.confirmation.cancelButton}
            confirmButtonText={dictionary.segments.confirmation.confirmButton}
            header={<ConfirmationHeader segmentName={segmentName} />}
            onConfirm={onConfirmationConfirmClick}
            onCancel={onConfirmationCancelClick}
            ref={confirmDialogRef}
            huggg={huggg}
            segment={selectedSegment ?? segments[0]}
        />
        {isGuidedChoice ? <GuidedChoiceFlow data-test-id="guided-choice-flow" onSelectSegment={onSelectSegment} /> : <SegmentCarousel data-test-id="segment-carousel" onSelectSegment={onSelectSegment} />}
    </Layout >
}

const mapStateToProps = state => {
    return {
        segments: getSegments(state),
        redeemedSegment: getRedeemedSegment(state),
        selectedSegment: getSelectedSegment(state),
        brand: getBrand(state)
    };
};

export const redeemedRedirectHandler = props => {
    const { isRedeemed, isMultiRedeemable } = props;
    const shouldRedirect = !isMultiRedeemable && isRedeemed;
    return [shouldRedirect, `${getBasePathname(props.huggg)}/redeemed`];
};

export const redeemableRedirectHandler = props => [
    !props.isRedeemable,
    `${getBasePathname(props.huggg)}/stash`
];

export const redeemRedirectHandler = props => {
    const { segments, huggg, redeemedSegment } = props;
    const isSingleSegment = segments?.length <= 1;
    return [isSingleSegment || Boolean(redeemedSegment), `${getBasePathname(huggg)}/redeem`]
}

export default compose(
    withHuggg,
    connect(mapStateToProps, { setSelectedSegment }),
    withRedirect(redeemedRedirectHandler),
    withRedirect(redeemableRedirectHandler),
    withRedirect(redeemRedirectHandler)
)(ChooseUnconnected);

